import React, { useState } from 'react';
import { StageScreen, StagePopup, popupHasContent } from './components/StageShell';

export default function Stage5Statement({ stage, pagesBg, onComplete }) {
  const startHasContent = popupHasContent(stage?.start_popup_image, stage?.start_popup_text);
  const endHasContent = popupHasContent(stage?.end_popup_image, stage?.end_popup_text);
  const [phase, setPhase] = useState(startHasContent ? 'start' : 'game');
  const [value, setValue] = useState('');
  const question = String(stage?.question_text ?? stage?.question ?? '').trim();
  const hint = String(stage?.hint_text ?? stage?.hint ?? '').trim();
  const answer = String(stage?.answer || '').trim();
  const correct = answer !== '' && value.trim().toLowerCase() === answer.toLowerCase();
  const finishStage = () => {
    if (endHasContent) setPhase('end');
    else onComplete({ answer: value });
  };

  if (phase === 'start') {
    return (
      <StageScreen pagesBg={pagesBg} pageKey="stage_5" stage={stage}>
        <StagePopup image={stage?.start_popup_image} text={stage?.start_popup_text} onNext={() => setPhase('game')} />
      </StageScreen>
    );
  }

  if (phase === 'end') {
    return (
      <StageScreen pagesBg={pagesBg} pageKey="stage_5" stage={stage}>
        <StagePopup image={stage?.end_popup_image} text={stage?.end_popup_text} onNext={() => onComplete({ answer: value })} />
      </StageScreen>
    );
  }

  return (
    <StageScreen pagesBg={pagesBg} pageKey="stage_5" stage={stage}>
      <div className="fi-stage-root fi-s5-root">
        {question ? <h2 className="fi-heading">{question}</h2> : null}
        {hint ? <p className="fi-intro-text">{hint}</p> : null}
        <input
          className={`fi-statement-input ${correct ? 'fi-statement-input--correct' : ''}`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={stage?.placeholder || 'Answer here'}
          readOnly={correct}
        />
        {correct ? (
          <div className="fi-actions"><button type="button" className="fi-btn fi-btn--primary" onClick={finishStage}>Continue</button></div>
        ) : null}
      </div>
    </StageScreen>
  );
}
